var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarningCircle = function SvgWarningCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.9 30c0-13.728 11.374-25.1 25.074-25.1C43.702 4.9 55.1 16.273 55.1 30 55.1 43.7 43.726 55.1 30 55.1 16.299 55.1 4.9 43.7 4.9 30ZM29.974 7.432c-12.53 0-22.515 10.04-22.515 22.566 0 12.527 10.011 22.567 22.54 22.567A22.484 22.484 0 0 0 52.568 30c0-12.53-10.066-22.566-22.593-22.566Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.975 34.412c-1.225 0-1.912-.687-1.936-1.937L27.72 19.51c-.024-1.25.907-2.157 2.23-2.157 1.3 0 2.28.931 2.256 2.181l-.368 12.941c-.024 1.275-.71 1.937-1.863 1.937Zm0 7.965c-1.421 0-2.647-1.152-2.647-2.549s1.201-2.549 2.647-2.549c1.422 0 2.623 1.128 2.623 2.55 0 1.42-1.226 2.548-2.623 2.548Z"
  })));
};
export default SvgWarningCircle;